import { render, staticRenderFns } from "./sensorAlertCard.vue?vue&type=template&id=c65f5a20"
import script from "./sensorAlertCard.vue?vue&type=script&lang=js"
export * from "./sensorAlertCard.vue?vue&type=script&lang=js"
import style0 from "./sensorAlertCard.vue?vue&type=style&index=0&id=c65f5a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports